import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const publicBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
});

export const baseQueryWithAuthHeaders = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: async (headers) => {
    const token = await localStorage.getItem(process.env.REACT_APP_TOKEN);

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});
